import React from "react";
import { useIntl } from "react-intl";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { MaterialTooltip } from "src/app/components/MaterialTooltip/MaterialTooltip";

export default function InfluencerCategoryInput({
  influencerCategoryValueInput,
  onChangeInfluencerCategoryValueInput,
  onKeyPress,
  isDisabled,
  label,
  dataCdtAttribute,
}) {
  const intl = useIntl();
  return (
    <div className="audience-search__field">
      <div className="audience-search__input">
        <div className="idh-label idh-label--with-tooltip">
          {label}
          <MaterialTooltip
            id="front_search_category_tooltip"
            content={
              <IDHFormattedMessage
                id="front_search_category_tooltip"
                defaultMessage="Search by influencer category."
              />
            }
          />
        </div>
        <input
          placeholder={intl.formatMessage({
            id: "front_search_category_placeholder",
            defaultMessage: "Search category...",
          })}
          value={influencerCategoryValueInput}
          onKeyPress={onKeyPress}
          onChange={onChangeInfluencerCategoryValueInput}
          disabled={isDisabled}
          data-cdt-input={dataCdtAttribute}
        />
      </div>
    </div>
  );
}
